import { Table } from "antd";
import styled from "styled-components";

export const TableComponent = styled(Table)`
    .ant-table-thead > tr > th {
        font-weight: bold !important;
        text-align: center !important;
        z-index: 1
    }
    .ant-table-tbody > tr > td {
       font-size: 13px;
       z-index: 1
    }
`